import { WidgetConfig } from 'controls/designer/features/widgets/widgetConfig';
import { WidgetDescription } from 'controls/designer/features/widgets/types';
import { allWidgets } from 'controls/designer/features/widgets/allWidgets';

export function getWidgetDescription<T extends WidgetConfig>(widgetType: string): WidgetDescription<T> {
	const module = allWidgets[widgetType];
	return module?.getWidgetDescription() as WidgetDescription<T>;
}
